import type { ReactNode } from "react";

export interface MobileShellProps {
  children: ReactNode;
  /** Fundo escuro (telas Login/Início com header índigo). */
  dark?: boolean;
}

/**
 * Shell do app mobile: ocupa a viewport inteira, como um aplicativo nativo. Sem
 * moldura de aparelho — o frame de iPhone (status bar, dynamic island, home
 * indicator) era apenas do protótipo de visualização. As safe areas (notch,
 * barra de status, barra de gestos) são respeitadas via `env(safe-area-inset-*)`
 * no header e na tab bar (ver components.css).
 */
export function MobileShell({ children, dark = false }: MobileShellProps) {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        background: dark ? "var(--surface-ink)" : "var(--paper)",
      }}
    >
      {children}
    </div>
  );
}
